import React, { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import styled from 'styled-components';
import { SubmitItemResult } from '../../../types/submitSequence';
import { SubmitItemResultInfo } from './SubmitItemResultInfo';

export const SubmitSequenceSummary: FC<{ results?: SubmitItemResult[] | null }> = ({ results }) => {
  const intl = useIntl();

  const submitFailed = useMemo(() => !!results?.find((r) => r.status?.errors?.length), [results]);

  if (!results) return null;

  return (
    <Wrapper>
      {results.map((x, i) => (
        <SubmitItemResultInfo key={i} itemResult={x} />
      ))}
      {submitFailed && (
        <ErrorMessage
          error={intl.formatMessage({ id: 'submitsteps.errors.submitabortedtryagain' })}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  > * {
    margin-bottom: 8px;
  }
`;
